// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  config : {
    apiKey: "AIzaSyAw4IVfJIR_HpDfAobsAMWgO8aES4eCSok",
  authDomain: "androidmanitech.firebaseapp.com",
  databaseURL: "https://androidmanitech.firebaseio.com",
  projectId: "androidmanitech",
  storageBucket: "androidmanitech.appspot.com",
  messagingSenderId: "52705768108",
  appId: "1:52705768108:web:416738448c053945bce509",
  measurementId: "G-9Q4JWT4GQM"
  }

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
